export default __webpack_public_path__ + "UI/assets/media/bg-pricing-card-component-7a9a4c7d.svg";